import React, { useEffect, useState, useMemo, useImperativeHandle } from 'react';
import { Form, Radio } from 'antd';
import SearchSelector from '../SearchSelector/SearchSelector';
import ListSearchItemsByIds from '../ListSearchItemsByIds/ListSearchItemsByIds';

const FormPrerequisites = ( { form, type = 'courses', modifiedCallback, ref } ) => {      
    const [ selectedModified, setSelectedModified ] = useState( false );
    
    useEffect( () => {
        form.setFieldsValue( { prerequistieIdsModified: form.getFieldValue( 'prerequistieIds' ) } );
        form.setFieldsValue( { prerequisiteAllModified: form.getFieldValue( 'prerequistieAll' ) } );
    }, [ form ] );

    useImperativeHandle( ref, () => ( {
        reset() { 
            form.setFieldsValue( { prerequistieIdsModified: form.getFieldValue( 'prerequistieIds' ) } );
            form.setFieldsValue( { prerequisiteAllModified: form.getFieldValue( 'prerequistieAll' ) } );
            form.setFieldsValue( { prerequistiesAreModified: false } );
            modifiedCallback( false );  
            setSelectedModified( false );
        }
    } ) );
    
    const isAllModified = () => {
        return form.getFieldValue( 'prerequistieAll' ) !== form.getFieldValue( 'prerequisiteAllModified' );
    };

    const handleAllChange = () => {
        modifiedCallback( isAllModified() || selectedModified ); 
    };

    const enableAll = useMemo( () => {
        const originalIds = form.getFieldValue( 'prerequistieIds' ) || [];
        const modIds = form.getFieldValue( 'prerequistieIdsModified' ) || [];
        
        return selectedModified 
            ? modIds.length > 0 
            : originalIds.length > 0;
    }, [ selectedModified, form ] );


    const handleOnChange = ( items ) => { 
        // Check is modified 
        if ( JSON.stringify( items ) !== JSON.stringify( form.getFieldValue( 'prerequistieIds' ) ) ) {
            form.setFieldsValue( { prerequistiesAreModified: true } );
            setSelectedModified( true );
            modifiedCallback( isAllModified() || true );
        } else {
            form.setFieldsValue( { prerequistiesAreModified: false } );
            modifiedCallback( false );
            setSelectedModified( false );
            modifiedCallback( isAllModified() );
        }
    };

    return (
        <div className="form-item-prerequisites">
            <h4>Prerequisites</h4>
            
            <Form.Item 
                name="prerequistieIdsModified"
                valuePropName="initialItems"
            >
                <SearchSelector 
                    type={ type }
                    showType={ false } 
                    alwaysDisabledItems={ [ form.getFieldValue( 'id' ) ] }
                    onChangeCallback={ handleOnChange }
                />
            </Form.Item>

            <Form.Item 
                name="prerequisiteAllModified" 
            >
                <Radio.Group 
                    size="small"
                    buttonStyle="solid" 
                    disabled={ !enableAll }
                    onChange={ handleAllChange }
                >
                    <Radio.Button value={ true }>All Required</Radio.Button>
                    <Radio.Button value={ false }>One Required</Radio.Button>
                </Radio.Group>
            </Form.Item>

            <Form.Item 
                name="prerequisiteOf"
                valuePropName="ids" 
            >
                <ListSearchItemsByIds 
                    type={ type } 
                    title="Prerequisite Of"
                />
            </Form.Item>
        </div>
    );
};

export default FormPrerequisites;
